export const JoinNetworkMixin = {
  methods: {
    joinNetwork(network) {
      console.log('Joinnetwork mixing', network);
      if (!this.$store.getters.auth) {
        this.$bus.emit(
          'show-sign-in',
          '/join-network?network=' + network.slug,
          this.$t('JoinNetworkMixin.to-access-this-network-login-or-start-your-journey-with-us-today')
        );
        return;
      }
      // Ask the user for confirmation first
      this.$bvModal.msgBoxConfirm(this.$t('network.confirmMembership')).then(value => {
        if (value) {
          this.$router.push('/join-network?network=' + network.slug);
        }
      });
      //.catch(() => { }) // cancelled
    },
  },
};
